import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jactoCurrency',
  standalone: false,
})
export class JactoCurrency implements PipeTransform {
  transform(value: any) {
    return 'R$ ' + value;
  }
}
